import './style.less';
import * as React from 'react';
import { Surface } from 'telstra-ui/components/surface/Surface';
import { SurfaceList, SurfaceListItem } from 'telstra-ui/components/list/List';
import {
    headerName,
    messages,
} from '@telstra-connect/service-requests/helpers/common-static-data';
import { Button } from 'telstra-ui/components/button/Button';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import global from '@applications';

export const NewCardLoadingIndicator = (loaderProps) => {
    const isError = loaderProps.error;
    const tileHeader = isError
        ? loaderProps.cardTitle
        : headerName.dashboardTileHeaderName;
    const dynamicStyleClass = !isError && 'tl-loading';
    const uiClass = !isError ? 'ui-card-loading' : 'ui-card-error';
    const isRedesignTilesPhase2 =
    global.applications.Platform.redesignTilesPhase2;
    const cardHeightClass = isRedesignTilesPhase2
        ? 'card-height-424px'
        : 'card-height-320px';
    return (
        <div className={`tc-srm-dashboard-surface-tile-loading ${cardHeightClass}`}>
            <Surface
                width="100%"
                className={`tl-custom-width tl-surface-dashboard ${uiClass} ${cardHeightClass}`}
                name="srm-surface-flat"
                id="ui-yps-card"
            >
                <div className="tl-card-inner-content">
                    <SurfaceList
                        header={
                            <div className="tl-heading__container" id="ui-yps-heading">
                                <div className={`__heading ${dynamicStyleClass}`}>
                                    {tileHeader}
                                </div>
                            </div>
                        }
                        body={isError ? RenderErrorBody() : RenderLinks()}
                        footer={
                            isError ? (
                                <div
                                    id="ui-yps-card-refresh"
                                    className="tc-yps-card-error__button"
                                    onClick={HandleOnClick}
                                >
                                    <SvgIcon
                                        name={'icon-system-refresh'}
                                        className="tc-footer-refresh-icon"
                                    />
                                    <span className="tc-footer-text">
                                        {headerName.dashboardTileRefresh}
                                    </span>
                                </div>
                            ) : (
                                <div className="__button tl-list-create-request-button">
                                    <Button
                                        variant="super"
                                        className="tl-loading"
                                        disabled={true}
                                        id="ui-yps-create-btn-loading"
                                    >
                                        {headerName.dashboardTileCreateRequest}
                                    </Button>
                                </div>
                            )
                        }
                    />
                </div>
            </Surface>
        </div>
    );
};

const RenderSkeletonLoader = (itemName) => {
    return (
        <SurfaceListItem
            itemHeading={itemName}
            itemIcon={'icon-system-chevron-right'}
            skeltonLoading={true}
        />
    );
};

const RenderLinks = () => {
    const isRedesignTilesPhase2 =
    global.applications.Platform.redesignTilesPhase2;
    return isRedesignTilesPhase2 ? (
        <div>
            {RenderSkeletonLoader(headerName.dashboardTileNetworksAndInternet)}
            {RenderSkeletonLoader(headerName.dashboardTileMobilitySolutionsLink)}
            {RenderSkeletonLoader(headerName.dashboardTileUnifiedCommunication)}
        </div>
    ) : (
        <div>
            {RenderSkeletonLoader(headerName.dashboardTileMobilitySolutionsLink)}
            {RenderSkeletonLoader(headerName.dashboardTileTrackRequests)}
        </div>
    );
};

const RenderErrorBody = () => {
    return (
        <div className="tc-yps-card-error">
            <div className="tc-yps-card-error__body">
                <SvgIcon
                    name={'picto-empty-state'}
                    className="tc-telstra-icon tc-yps-card-error__body__icon"
                />
                <div
                    className="tc-yps-card-error__body__icon__error"
                    id="ui-yps-card-error-text"
                >
                    {messages.loadingError}
                </div>
                <div
                    className="tc-yps-card-error__body__icon__text"
                    id="ui-yps-card-error-subtext"
                >
                    {messages.errorIndicator}
                </div>
            </div>
        </div>
    );
};
const HandleOnClick = () => {
    return window.location.reload();
};
